import { axios } from '@/utils/request'
const API = {
  findClassesDetail: '/b/classes/theme/v2/findClassesDetail', // 获取我的贴子
  findClassesDetailV2: '/b/classes/theme/v2/findClassesDetail', // 获取我的贴子
  addTheme: '/b/classes/theme/v2/addTheme', // 新增贴子
  addWatchNum: '/b/classes/theme/v2/addWatchNum', // 增加贴子访问数
  findTheme: '/b/classes/theme/v2/findThemeById', // 根据id获取贴子详情
  deleteTheme: '/b/classes/theme/v2/deleteTheme', // 删除贴子
  isThemeZan: '/b/classes/theme/v2/isThemeZan', // 是否对某贴子点赞
  addZan: '/b/classes/theme/v2/addZan', // 对贴子点赞
  cancelZan: '/b/classes/theme/v2/cancelZan', // 取消点赞
  // findComment: '/b/classes/comments/findComment', // 获取贴子下的评论
  findStudentComment: '/b/classes/comments/v2/findStudentComment', // 获取贴子下学生的评论
  findTeacherComment: '/b/classes/comments/v2/findTeacherComment', // 获取贴子下老师的评论
  adoptComment: '/b/classes/comments/v2/adoptComment', // 采纳回复
  opComment: '/b/classes/comments/v2/opComment', // 给评论操作（点赞，点踩）
  addComment: '/b/classes/comments/v2/addComment', // 给贴子回复
  findReplyMyComments: '/b/classes/comments/v2/findReplyMyComments', // 回复我的
  findReplyMyCommentsV2: '/b/classes/comments/v2/findReplyMyComments', // 回复我的
  findMyComments: '/b/classes/comments/v2/findMyComments', // 我的评论
  findMyCommentsV2: '/b/classes/comments/v2/findMyComments', // 我的评论
  deleteComment: '/b/classes/comments/v2/deleteComment' // 删除评论
}

// 获取我的贴子
export const findClassesDetail = params => {
  return axios({
    url: API.findClassesDetailV2,
    method: 'GET',
    params: params
  })
}

// 新增贴子
export const addTheme = data => {
  return axios({
    url: API.addTheme,
    method: 'POST',
    data
  })
}
// 增加贴子访问数
export const addWatchNum = themeId => {
  return axios({
    url: `${API.addWatchNum}?themeId=${themeId}`,
    method: 'PUT'
  })
}
// 根据id获取贴子详情
export const findTheme = themeId => {
  return axios({
    url: `${API.findTheme}?themeId=${themeId}`,
    method: 'GET'
  })
}
// 删除贴子
export const deleteTheme = themeId => {
  return axios({
    url: `${API.deleteTheme}?themeId=${themeId}`,
    method: 'DELETE'
  })
}

// 是否对某贴子点赞
export const isThemeZan = themeId => {
  return axios({
    url: `${API.isThemeZan}?themeId=${themeId}`,
    method: 'GET'
  })
}

// 点赞
export const addZan = themeId => {
  return axios({
    url: `${API.addZan}?themeId=${themeId}`,
    method: 'PUT'
  })
}
// 取消点赞
export const cancelZan = themeId => {
  return axios({
    url: `${API.cancelZan}?themeId=${themeId}`,
    method: 'PUT'
  })
}
// 获取贴子下学生的评论
export const findStudentComment = params => {
  return axios({
    url: API.findStudentComment,
    method: 'GET',
    params
  })
}
// 采纳回复
export const adoptComment = params => {
  return axios({
    url: API.adoptComment,
    method: 'POST',
    params
  })
}
// 给评论操作（点赞，点踩）
export const opComment = params => {
  return axios({
    url: API.opComment,
    method: 'POST',
    params
  })
}
// 获取贴子下老师的评论
export const findTeacherComment = params => {
  return axios({
    url: API.findTeacherComment,
    method: 'GET',
    params
  })
}
// 给贴子评论
export const addComment = data => {
  return axios({
    url: API.addComment,
    method: 'POST',
    data
  })
}
// 回复我的
export const findReplyMyComments = params => {
  return axios({
    url: API.findReplyMyCommentsV2,
    method: 'GET',
    params
  })
}
// 贴子评论列表
export const findMyComments = params => {
  return axios({
    url: API.findMyCommentsV2,
    method: 'GET',
    params
  })
}
// 删除贴子评论
export const deleteComment = params => {
  return axios({
    url: API.deleteComment,
    method: 'DELETE',
    params
  })
}
